import { Box, Button, Typography } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import notFoundIcon from 'shared/assets/svg/404.svg';
import { getRouteHome } from 'shared/const/router';
import { innerPageHeight } from 'shared/const/styles';
import { NeedAnyAssistance } from 'shared/ui/NeedAnyAssistance/NeedAnyAssistance';
import { Page } from 'widgets/Page';

export const NotFoundPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const onClick = useCallback(async () => {
        navigate(getRouteHome());
    }, [navigate]);

    return (
        <Page dataTestId="NotFoundPage">
            <Box
                display="flex"
                justifyContent="center"
                height={innerPageHeight}
                sx={{ overflowY: 'scroll' }}
            >
                <Box
                    width="100%"
                    maxWidth="400px"
                    display="flex"
                    alignItems="center"
                    flexDirection="column"
                >
                    <Typography variant="h1" mt="40px" mb="42px">
                        {t('Page Not Found')}
                    </Typography>

                    <Box mb="74px">
                        <img src={String(notFoundIcon)} alt={t('Not found')} />
                    </Box>

                    <Typography mb="16px" variant="h2" textAlign="center">
                        {t('Sorry, the page you’ve requested is not found')}
                    </Typography>

                    <Typography mb="76px" variant="body1" textAlign="center">
                        {t('Please go back to Home page')}.
                    </Typography>

                    <Box mb="120px" width="100%">
                        <Button
                            onClick={onClick}
                            fullWidth
                            variant="contained"
                            data-testid="NotFoundPage.Button"
                        >
                            {t('Go to home page')}
                        </Button>
                    </Box>

                    <NeedAnyAssistance />
                </Box>
            </Box>
        </Page>
    );
};
